module.exports = __webpack_public_path__ + "static/SL55-2680e075623ca0a6359e406ec359d175.png";